import { render, staticRenderFns } from "./CopSavingsWidget.vue?vue&type=template&id=7c7eb515&scoped=true&"
import script from "./CopSavingsWidget.vue?vue&type=script&lang=js&"
export * from "./CopSavingsWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7eb515",
  null
  
)

export default component.exports